import { useState } from "react"
import type { Event } from "@apps/gwservice/types"
import { EventSheet } from "~/features/calendar/components/event-sheet"
import { Carousel } from "@mylaunch/components/ui"
import { EventCard } from "./event-card"
import { useEvents } from "../hooks/use-events"
import { feedEventsQueryKey } from "../query-keys"

export function EventsCarousel() {
  const { data: events } = useEvents()
  const [selected, setSelected] = useState<Event | null>(null)

  function handleClose() {
    setSelected(null)
  }

  return (
    <>
      <Carousel
        className="gap-0!"
        items={events}
        getKey={(e) => e.id}
        renderItem={(e) => <EventCard event={e} onClick={() => setSelected(e)} />}
      />
      <EventSheet event={selected} onClose={handleClose} queryKey={feedEventsQueryKey()} />
    </>
  )
}
